define('gameday-index-gdaudio/subcomponents/MediaUrlFetcher',['require','exports','module','jquery','bam.cookies/cookies','auth-media-gateway/AuthenticatedMediaGateway','message-service/message-service','gameday-index-enums/enums/events/OauthEvents','gameday-index-enums/enums/events/DisplayEvents','app-console/app-console'],function(require, exports, module) {
	var $ = require("jquery"),
		cookies = require("bam.cookies/cookies"),
		AuthGate = require("auth-media-gateway/AuthenticatedMediaGateway"),
		MessageService = require("message-service/message-service"),
		OauthEvts = require("gameday-index-enums/enums/events/OauthEvents"),
		DisplayEvts = require("gameday-index-enums/enums/events/DisplayEvents"),
		logg = require("app-console/app-console");

	var COOKIE = "mssk",
		PB_SCENARIO = "AUDIO_FMS_32K",
		authGate = new AuthGate.getInstance(),
		mediaItem;

	function MediaUrlFetcher() {
		authGate.configure({
			secureHost: "secure.mlb.com",
			frameworkURL: "",
			frameworkEndPoint: "/pubajaxws/bamrest/MediaService2_0/op-findUserVerifiedEvent/v-2.3",
			profileServiceEndPoint: null,
			bypassLogin: true
		});
	}

	function handleStreamReturns(payload, evt) {
		var evtType = evt.type;
		var evtType = (evtType.indexOf("MessageService") >= 0) ? evtType.substr(evtType.indexOf("::") + 2) : evtType;

		if (evtType !== OauthEvts.MEDIA_ITEM_PLAYABLE) {
			
			if (evtType === OauthEvts.MEDIA_ITEM_NOT_AUTHORIZED)  {
		      MessageService.publish(OauthEvts.isLoginNoEntitlement);
		    }
		
			logg.log(evtType + " :: " + "So sorry, dude, I cannot play anything back for you today. Try again, but maybe do it right next time, huh?");
			return;
		}

		mediaItem = payload;
		logg.log(mediaItem);
		MessageService.publish(DisplayEvts.playAuidoFeed, mediaItem);
	}

	MediaUrlFetcher.prototype = {
		mediaVO: mediaItem,

		getURL: function(eventID, contentID) {
			MessageService.one(OauthEvts.MEDIA_ITEM_PLAYABLE, handleStreamReturns);
			MessageService.one(OauthEvts.MEDIA_ITEM_ERROR, handleStreamReturns);
			MessageService.one(OauthEvts.MEDIA_ITEM_BLACKOUT, handleStreamReturns);
			MessageService.one(OauthEvts.MEDIA_ITEM_NOT_AUTHORIZED, handleStreamReturns);

			authGate.requestMedia({
				event_id: eventID,
				content_id: contentID,
				playback_scenario: PB_SCENARIO,
				identityPointId: cookies.get("ipid"),
				fingerprint: cookies.get("fprt")
			});

		}
	};

	return MediaUrlFetcher;
});
